var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8 16.1v-5.4C8 8.2 9.7 6 12 5.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M19.1 5.1h9.8c3.1 0 5.7 2.5 5.7 5.7v21c0 3.1-2.5 5.7-5.7 5.7H13.7C10.6 37.5 8 35 8 31.8V16.2L19.1 5.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4D_main",
    d: "M16.3 19l5.5-5.4 5.5 5.4M21.8 15.1v13.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.1 5.1L12 12.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.8,
    cy: 33.6,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFilled);
export default __webpack_public_path__ + "static/media/documentFilled.bda6170a7a7d85070818eedb60107822.svg";
export { ForwardRef as ReactComponent };